(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdowns() {
    document.querySelectorAll('[data-ss-countdown]').forEach(function (el) {
      var endStr = el.getAttribute('data-ss-countdown');
      if (!endStr) return;
      var end = new Date(endStr.indexOf('T') > -1 ? endStr : endStr + 'T23:59:59').getTime();
      if (isNaN(end)) return;

      function tick() {
        var diff = Math.max(0, end - Date.now());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        el.querySelectorAll('[data-unit]').forEach(function (unit) {
          var key = unit.getAttribute('data-unit');
          var val = key === 'days' ? d : key === 'hours' ? h : key === 'mins' ? m : s;
          unit.textContent = pad(val);
        });
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function initCounters() {
    var items = document.querySelectorAll('[data-ss-counter]');
    if (!items.length) return;

    function animate(el) {
      if (el.dataset.counted) return;
      el.dataset.counted = '1';
      var target = parseInt(el.getAttribute('data-ss-counter'), 10) || 0;
      var suffix = el.getAttribute('data-ss-suffix') || '';
      var duration = reduced ? 0 : 1800;
      var startTime = null;

      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = duration === 0 ? 1 : Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = Math.floor(target * eased);
        el.textContent = current.toLocaleString() + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      items.forEach(function (el) { obs.observe(el); });
    } else {
      items.forEach(animate);
    }
  }

  function initReviewsCarousel() {
    document.querySelectorAll('[data-ss-reviews-carousel]').forEach(function (section) {
      var track = section.querySelector('[data-reviews-track]');
      if (!track || reduced) return;
      var originals = Array.prototype.slice.call(track.children);
      if (originals.length < 2) return;
      originals.forEach(function (card) {
        track.appendChild(card.cloneNode(true));
      });
    });
  }

  function init() {
    try {
      initCountdowns();
      initCounters();
      initReviewsCarousel();
    } catch (e) {
      console.error('ss-phase06 init error', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
